import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import WhatsAppButton from "@/components/ui/WhatsAppButton";

const RestitutionSection: React.FC = () => {
  return (
    <section id="restituicao" className="py-8 md:py-16 px-4 md:px-6 bg-background scroll-mt-28 md:scroll-mt-32">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-6 md:mb-10">
          <p className="text-xs tracking-widest font-medium uppercase text-primary mb-2">
            RESTITUA IMPOSTOS
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">
            Reveja valores pagos em impostos
          </h2>
        </div>

        <Card className="shadow-sm">
          <CardContent className="p-4 md:p-6 space-y-4 text-muted-foreground leading-relaxed">
            <p>
              Além disso, se você pagou impostos em excesso por anos, a Tax Health pode ajudar a corrigir essa situação.
            </p>
            <p>
              Garantimos que você receba a <strong className="text-foreground">restituição corrigida dos valores pagos erroneamente nos últimos 60 meses</strong>.
            </p>
            <p>
              Nossa equipe de especialistas está sempre atualizada em relação à legislação tributária e às melhores práticas fiscais, garantindo que você receba a assessoria mais precisa e eficiente possível.
            </p>
            <p>
              Trabalhamos de forma personalizada, analisando cada detalhe da situação tributária do seu negócio para encontrar as soluções mais adequadas e vantajosas para você.
            </p>

            <div className="pt-4">
              <WhatsAppButton 
                text="QUERO UM CONTATO"
                source="restitution_section"
                size="lg"
                className="w-full md:w-auto min-h-[48px]"
                showIcon={false}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default RestitutionSection;
